import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoIdentityBloc from "../../blocs/retirement/info-perso/REInfoIdentityBloc";
import useAppState from "../../context/AppContext";
import { IContactType } from "../../context/model";
import { dataEditableByAdvisor } from "../../const/AppConst";


export default function REInfoIdentityPage() {
  const {
    state: { proposition }
  } = useAppState();

  const isClient = proposition?.configuration?.byContactType === IContactType.CLIENT;

  const pageGapRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

   
  return (
    <div className="entreprise-container">
      
      <h1 className="title ml-lg-desktop mb-sm">Complétez votre identité</h1>
      {isClient && <p className="text ml-lg-desktop mr-lg-desktop" style={{textAlign: 'justify'}}>{dataEditableByAdvisor}</p>}
      
      <div ref={pageGapRef} className="page-gap" />
      <div className="flex-grid m-lg-desktop">
          <REInfoIdentityBloc />
      </div>
    </div>
  
  )
}